export default __webpack_public_path__ + "static/Tokens-40145c200fdfe378cea919fc6bdf1535.svg";